import { render, staticRenderFns } from "./gc-popup-validation-summary.vue?vue&type=template&id=50a6b1a8&"
import script from "./gc-popup-validation-summary.vue?vue&type=script&lang=js&"
export * from "./gc-popup-validation-summary.vue?vue&type=script&lang=js&"
import style0 from "./gc-popup-validation-summary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports